import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import {ModalConfig, UiTranslateLoaderService} from 'ui-shared';
import {PositionPickerListComponent} from './position-picker-list.component';
import {PositionModel} from '../../position-management/model/position-model';
import {PositionQueryModel} from '../../position-management/model/position-query-model';

@Component({
    selector: 'position-picker',
    templateUrl: './position-picker.component.html',
})
export class PositionPickerComponent {
    dynamicDialogRef: DynamicDialogRef;

    @Input() selectionMode: string = 'single';
    @Input() positionPicker: PositionModel[] = [];
    @Input() disabled: boolean = false;
    @Input() queryModel: PositionQueryModel;
    @Output() valueEvent = new EventEmitter<any>();
    @Input() dataKey: string = 'id';
    @Input() showCountOnly: boolean = false;
    @Input() showFullStaffDetail:boolean=false;
    @Input() showAvailableStaff:boolean=false;
    @Input() showDate:boolean=false;

    constructor(
        private dialogService: DialogService,
        private uiTranslateService: UiTranslateLoaderService,
    ) {
    }

    onShow() {
        this.dynamicDialogRef = this.dialogService.open(PositionPickerListComponent, {
            width: ModalConfig.MODAL_WIDTH,
            header: this.uiTranslateService.instant('hrPerPosition.list'),
            contentStyle: {
                height: ModalConfig.MODAL_MAX_HEIGHT,
                'max-height': ModalConfig.MODAL_MAX_HEIGHT,
                overflow: 'auto',
            },
            data: {
                selectionMode: this.selectionMode,
                posPickerData: this.positionPicker,
                queryModel: this.queryModel,
                dataKey: this.dataKey,
                showFullStaffDetail: this.showFullStaffDetail,
                showAvailableStaff: this.showAvailableStaff,
                showDate: this.showDate,
            },
        });

        this.dynamicDialogRef.onClose.subscribe((model) => {
            if(model==null){
                this.valueEvent.emit(null);
                this.positionPicker=null;
                return
            }
            if (this.selectionMode == 'single') {
                if (!Array.isArray(model)) {
                    this.positionPicker = [model];
                }
            } else {
                this.positionPicker = model;
            }
            this.valueEvent.emit(model);
        });
    }

    onRemove() {
        this.positionPicker = [];
        this.valueEvent.emit([]);
    }
}
